import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetCaseStudyDetail } from "../../api/requests/caseStudies";
import { CaseStudy } from "../../models/work";
import WorkDetail from "../../views/workDetail";

interface Props {
  data: CaseStudy;
}

function Index({ data }: Props) {
  return <WorkDetail data={data} />;
}

export async function getServerSideProps({ locale, query }: any) {
  const { success, data } = await GetCaseStudyDetail(query.slug);

  return {
    props: {
      ...(await serverSideTranslations(locale, ["translation"])),
      data: success ? data : {}
    },
  };
}

export default Index;
